import { nullify } from "./miscUtil";

export default class NumberString {
    private value: string;
    private readonly zeroAsNull: boolean;

    constructor(value?: string | number | NumberString, zeroAsNull: boolean = false) {
        this.value = value?.toString() ?? '';
        this.zeroAsNull = zeroAsNull;
    }

    get stringValue(): string {
        return this.value;
    }

    get numberValue(): number {
        const numValue = Number(this.value.replace(',', '.'));
        return Number.isNaN(numValue) ? 0 : numValue;
    }

    get nullStringValue(): string | null {
        return nullify(this.value);
    }

    get nullNumberValue(): number | null {
        const nullString = this.nullStringValue;
        if (!nullString) return null;
        const numValue = Number(nullString.replace(',', '.'));
        if (Number.isNaN(numValue)) return null;
        if(!numValue) return this.zeroAsNull ? null : 0;
        return numValue;
    }

    setValue = (value: string | number): NumberString => {
        this.value = value.toString();
        return this;
    }

    toString = () => {
        return this.stringValue;
    }
}